import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GFIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GF" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#5EAA22" d="M0 0h16v12H0z" />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="m0 0 16 12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E21835"
        fillRule="evenodd"
        d="M7.965 7.203 6.223 8.412l.556-2.07L5.5 5.018l1.732-.072.733-2.047.733 2.047h1.73L9.15 6.341l.64 1.949-1.826-1.087Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
